import { render, staticRenderFns } from "./SiteVersionElement.vue?vue&type=template&id=d06569f8&scoped=true&"
import script from "./SiteVersionElement.vue?vue&type=script&lang=js&"
export * from "./SiteVersionElement.vue?vue&type=script&lang=js&"
import style0 from "./SiteVersionElement.vue?vue&type=style&index=0&id=d06569f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06569f8",
  null
  
)

export default component.exports